import { useEffect, useRef } from 'react'
import { getStateListPromise } from 'apis/FitOnCareAPI'
import { getStateId } from 'utils/authLocalStorage'
import { useStateList } from 'contexts/AuthContext'

export const isMcaStateRestricted = (state) => state?.mcaAvailable !== true

export const MCA_STATE_NOT_SUPPORTED = 'state_not_supported'

let restrictedState = { code: '', name: '' }

export const setRestrictedState = (state) => {
  restrictedState = {
    code: state?.code || '',
    name: state?.name || '',
  }
}

export const getRestrictedState = () => restrictedState

const findStateById = (list, stateId) =>
  (list || []).find((item) => item.id === +stateId) || null

export const useMcaStateGate = () => {
  const { stateList } = useStateList()
  const stateListRef = useRef(stateList)
  useEffect(() => {
    stateListRef.current = stateList
  }, [stateList])

  const lookupCurrentUserState = async () => {
    const stateId = getStateId()
    if (!stateId) return null
    const cached = findStateById(stateListRef.current, stateId)
    if (cached) return cached
    const resp = await getStateListPromise().catch(() => null)
    return findStateById(resp?.stateList, stateId)
  }

  return { lookupCurrentUserState }
}
